const getters = {
  states: (state) => state.states,
  stateContainer: (state) => state.stateContainer,
}

export { getters }
